<template>
	<App>
		<AppBar>
			<div class="flex-wrap" style="font-size: 16px">
				<BaseIcon icon="edit" :size="24" style="margin-right: 5px" />
				填写表单:{{ form.name }}
			</div>
			<div>
				<Input search />
			</div>
		</AppBar>
		<AppClient class="" style="background:var(--bg2)">
      <div class="contianer flex-wrap flex-line align-start" style="background:var(--bg2)">
      <div style="width:860px;padding:40px;overflow:hidden;position:relative;background:var(--bg3);flex-shrink:0;">
       <FormInstance  class="docx" :form="form" :data="formData" @change="changed=$event" :editable="true" />
       <div class="flex-wrap flex-right" style="margin-top:20px;padding:0 45px">
        <Button type="primary" size="large">提交</Button>
       </div>
      </div>
      {{changed}}
      </div>
    </AppClient>
	</App>
</template>

<script>
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppClient from '@/components/app/client';
import Tabs from '@/components/app/tabs2';
import FormInstance from '@/components/form/html';
export default {
  data() {
    return {
      form: {},
      formData: {},
      changed: {},
    };
  },
  components: {App, AppBar, AppClient, Tabs, FormInstance},
  routerOption: {
    as_object: true,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.get('docxt/' + this.id).then((res) => {
        this.form = res.data.data;
      });
    },
  },
};
</script>

<style lang="less">
.docx{
  img{
    width:100%;
  }

    font-family:'仿宋';
    font-size:16px;

    h1{
      text-align: center;
      font-size:24px;
      margin:10px 0;
    }
    table{
      border:3px solid var(--text3);
      border-collapse: collapse;
      width:680px;
      margin:0 auto;
      tr:first-child{
        td{
          width:100px;
          height:0;
          border:none;
        }
      }
      td{
        border:1px solid var(--text3);
        height:60px;
        text-align:center;
        vertical-align:middle;
      }
      tr{

      }
    }
}
</style>
